import { useQuery } from "react-query";
import { filterCategory } from "../land-Use/helpers/helpers";


const getPropertyDetails = ({userInfo, applicationFlow }) => {
  const tenantId = Digit.ULBService.getStateId();
  const consultantCategory = filterCategory(userInfo?.roles);
  const applicationData = {
    tenantId,
    professionalInformation: {
      name: userInfo?.name,
      mobileNumber: userInfo?.mobileNumber,
      consultantCategory: consultantCategory,
      emailId: userInfo?.emailId,
      businessService: "BPA_KYP",
    //   planDate: validity,
      address: {
        address: userInfo?.permanentAddress,
        district: null,
        state: null,
      },
      //certificateNumber: usersData?.[0]?.registrationArchitectNumber,
      //licenseNumber: usersData?.[0]?.registrationNumber,
    //   planDate: validity,
      // registrationNumber: userInfo?.registrationNumber,
      // registrationArchitectNumber: registrationArchitectNumber,
    },
    department: applicationFlow,
    landAreaDetails: {
      city: null,
      locality: null,
      village: null,
      areaType: null,
    },
    descriptionOfLand: {
      revenueVillageMohal: null,
      propertyType: null,
      khataNo: null,
      multipleKhasra: [{ khasraNo: "", area: "" }],
      khatauniNo: null,
      areaForCluSqM: 0,
      nameofConcerned: null,
      natureOfTower: null,
      towerToBeProposed: null,
      proposedGoundCoverageSqM: null,
      whetherUsedBySingleCompany: null,
      installationFeesDeposited: null,
      nameofConcerned: null,
      sectorNo: null,
      schemeName: null,
      approachRoadWidths: null,
      totalPlotArea: 0,
      appliedLandUse: {
        name: null,
      },
      whetherUsedBySingleCompany: null,
      propertyType: {
        name: null,
      },
      installationFeesDeposited: null,
      isChangeOfLandInvolved: null,
      typeOfCLUInvolved: {
        name: null,
      },
    },
    activeTab: sessionStorage.getItem("LANDUSE_CURRENT_TAB") || 0,
    applicationType: "FORM_KYP",
    feeType: "ApplicationFee",
    workflow: { action: "INITIATE" },
    landInfo: {
      owners: [
        {
          name: null,
          fatherOrHusbandName: null,
          aadhaarNumber: "",
          mobileNumber: "",
          emailId: "",
          gender: null,
          correspondenceAddress: {
            applicantName: null,
            applicantGuardianName: null,
            state: "",
            district: null,
            tehsil: null,
            town: null,
            address: "",
            pinno: "",
            type: "CORRESPONDENCE",
          },
          permanentAddress: {
            applicantName: null,
            applicantGuardianName: null,
            state: "",
            district: null,
            tehsil: null,
            town: null,
            address: "",
            pinno: "",
            type: "PERMANENT",
          },
        },
      ],
      tenantId,
    },
    nocDetails: {
      applicantNOCData: null,
      additionalApplicantNOC: null,
      officerNOCData: null,
      additionalOfficerNOC: null,
      checkedByOfficer: null,
    },
    businessService: null,
    documents: [],
    uiFlow: { flow: "Form_KYP" },
  };

  return { applicationData, isAppDataLoading: false };
};
export default getPropertyDetails;
